import {
  AwesomerRoot,
  BackgroundImage,
  BackgroundImageMobile,
  ContentWrapper,
} from './Awesomer.styles'
import { Button } from 'components/Button'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import { SectionTitle } from 'features/Reviews/Reviews.styles'
import Trans from 'next-translate/Trans'
import Image from 'next/image'
import background from '../../../../../public/assets/reviews/awesome.png'
import mobileBackground from '../../../../../public/assets/recipes/categories/preparing-meal.png'
import Link from 'next/link'
export const Awesomer = () => {
  const { t } = useTranslation()

  return (
    <AwesomerRoot>
      <BackgroundImage className="desktop-only">
        <Image src={background} alt={t('reviews:awesomer.bgImageAlt')} />
      </BackgroundImage>
      <BackgroundImageMobile className="mobile-only">
        <Image
          layout="fill"
          objectFit="cover"
          objectPosition="64% 0%"
          src={mobileBackground}
          alt={t('reviews:awesomer.bgImageAlt')}
        />
      </BackgroundImageMobile>
      <ContentWrapper>
        <SectionTitle className='desktop-only' align="center" color="secondary">
          <Trans components={{ br: <br /> }} i18nKey={'reviews:awesomer.title'} />
        </SectionTitle>
        <SectionTitle className='mobile-only' align="center" color="secondary">
          <Trans components={{ br: <br /> }} i18nKey={'reviews:awesomer.title-mobile'} />
        </SectionTitle>
        <Stack width="fullWidth" direction="column" gap="2" alignItems="center">
          <Link href="meal-plan">
            <Button variant="primary">
              {t('reviews:awesomer.cta-1')}
            </Button>
          </Link>
          <Link href="products">
            <Button variant="tertiary">
              {t('reviews:awesomer.cta-2')}
            </Button>
          </Link>
        </Stack>
      </ContentWrapper>
    </AwesomerRoot>
  )
}
